import { Component, Input, type OnInit } from '@angular/core';
import { isFuture } from 'date-fns';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import type { TimerLabels } from '../timer.model';
import { Image } from './timer-widget-wrapper/timer-widget-wrapper.model';
import { TimerComponent } from '../timer.component';

@Component({
  selector: 'wl-timer-widget',
  templateUrl: './timer-widget.component.html',
  styleUrls: [
    './timer-widget.component.ed.scss',
    './timer-widget.component.essent.scss',
  ],
  standalone: true,
  imports: [AutomationIdDirective, TimerComponent],
})
export class TimerWidgetComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) dateToCountDownTo: Date | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() timerLabels?: Partial<TimerLabels>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() image?: Image;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() text?: string;

  timerWidgetShown = false;

  hideTimerWidget = (): void => {
    this.timerWidgetShown = false;
  };

  ngOnInit(): void {
    if (this.dateToCountDownTo && isFuture(this.dateToCountDownTo)) {
      this.timerWidgetShown = true;
    }
  }
}
